import React, { memo } from 'react'

import Text from '../../text/Text'
import TextLink from '../../text/TextLink'

const LoginLinkText = ({ label, actionLabel, to }) => {
  return (
    <Text
      variant='body2'
      sx={{ color: 'text.secondary' }}
      label={
        <>
          {label}
          <TextLink label={actionLabel} to={to} />
        </>
      }
    />
  )
}

export default memo(LoginLinkText)
